import { __decorate } from 'tslib';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, NgZone, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { defineCustomElements } from '@vime/core/loader';
import { findRootPlayer, createDispatcher, usePlayerContext } from '@vime/core';
import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
export * from '@vime/core';

const proxyInputs = (Cmp, inputs) => {
    const Prototype = Cmp.prototype;
    inputs.forEach((item) => {
        Object.defineProperty(Prototype, item, {
            get() {
                return this.el[item];
            },
            set(val) {
                this.z.runOutsideAngular(() => (this.el[item] = val));
            },
        });
    });
};
const proxyMethods = (Cmp, methods) => {
    const Prototype = Cmp.prototype;
    methods.forEach((methodName) => {
        Prototype[methodName] = function () {
            const args = arguments;
            return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
        };
    });
};
const proxyOutputs = (instance, el, events) => {
    events.forEach((eventName) => (instance[eventName] = fromEvent(el, eventName)));
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
    const decorator = function (cls) {
        if (opts.inputs) {
            proxyInputs(cls, opts.inputs);
        }
        if (opts.methods) {
            proxyMethods(cls, opts.methods);
        }
        return cls;
    };
    return decorator;
}

let VimeAudio = class VimeAudio {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeAudio.ɵfac = function VimeAudio_Factory(t) { return new (t || VimeAudio)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeAudio.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeAudio, selectors: [["vime-audio"]], inputs: { crossOrigin: "crossOrigin", disableRemotePlayback: "disableRemotePlayback", mediaTitle: "mediaTitle", preload: "preload" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeAudio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeAudio.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeAudio = __decorate([
    ProxyCmp({
        inputs: ['crossOrigin', 'disableRemotePlayback', 'mediaTitle', 'preload']
    })
], VimeAudio);
let VimeCaptionControl = class VimeCaptionControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeCaptionControl.ɵfac = function VimeCaptionControl_Factory(t) { return new (t || VimeCaptionControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeCaptionControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeCaptionControl, selectors: [["vime-caption-control"]], inputs: { hideIcon: "hideIcon", hideTooltip: "hideTooltip", keys: "keys", showIcon: "showIcon", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeCaptionControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeCaptionControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeCaptionControl = __decorate([
    ProxyCmp({
        inputs: ['hideIcon', 'hideTooltip', 'keys', 'showIcon', 'tooltipDirection', 'tooltipPosition']
    })
], VimeCaptionControl);
let VimeCaptions = class VimeCaptions {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vTrackChange', 'vCuesChange']);
    }
};
VimeCaptions.ɵfac = function VimeCaptions_Factory(t) { return new (t || VimeCaptions)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeCaptions.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeCaptions, selectors: [["vime-captions"]], inputs: { controlsHeight: "controlsHeight", hidden: "hidden" }, outputs: { vTrackChange: "vTrackChange", vCuesChange: "vCuesChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeCaptions_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeCaptions.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeCaptions = __decorate([
    ProxyCmp({
        inputs: ['controlsHeight', 'hidden']
    })
], VimeCaptions);
let VimeClickToPlay = class VimeClickToPlay {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeClickToPlay.ɵfac = function VimeClickToPlay_Factory(t) { return new (t || VimeClickToPlay)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeClickToPlay.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeClickToPlay, selectors: [["vime-click-to-play"]], inputs: { useOnMobile: "useOnMobile" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeClickToPlay_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeClickToPlay.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeClickToPlay = __decorate([
    ProxyCmp({
        inputs: ['useOnMobile']
    })
], VimeClickToPlay);
let VimeControl = class VimeControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vInteractionChange']);
    }
};
VimeControl.ɵfac = function VimeControl_Factory(t) { return new (t || VimeControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeControl, selectors: [["vime-control"]], inputs: { expanded: "expanded", hidden: "hidden", identifier: "identifier", keys: "keys", label: "label", menu: "menu", pressed: "pressed" }, outputs: { vInteractionChange: "vInteractionChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeControl = __decorate([
    ProxyCmp({
        inputs: ['expanded', 'hidden', 'identifier', 'keys', 'label', 'menu', 'pressed']
    })
], VimeControl);
let VimeControlGroup = class VimeControlGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeControlGroup.ɵfac = function VimeControlGroup_Factory(t) { return new (t || VimeControlGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeControlGroup.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeControlGroup, selectors: [["vime-control-group"]], inputs: { space: "space" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeControlGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeControlGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeControlGroup = __decorate([
    ProxyCmp({
        inputs: ['space']
    })
], VimeControlGroup);
class VimeControlSpacer {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
VimeControlSpacer.ɵfac = function VimeControlSpacer_Factory(t) { return new (t || VimeControlSpacer)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeControlSpacer.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeControlSpacer, selectors: [["vime-control-spacer"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeControlSpacer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeControlSpacer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let VimeControls = class VimeControls {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeControls.ɵfac = function VimeControls_Factory(t) { return new (t || VimeControls)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeControls.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeControls, selectors: [["vime-controls"]], inputs: { activeDuration: "activeDuration", align: "align", direction: "direction", fullHeight: "fullHeight", fullWidth: "fullWidth", hidden: "hidden", hideOnMouseLeave: "hideOnMouseLeave", hideWhenPaused: "hideWhenPaused", justify: "justify", pin: "pin", waitForPlaybackStart: "waitForPlaybackStart" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeControls_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeControls.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeControls = __decorate([
    ProxyCmp({
        inputs: ['activeDuration', 'align', 'direction', 'fullHeight', 'fullWidth', 'hidden', 'hideOnMouseLeave', 'hideWhenPaused', 'justify', 'pin', 'waitForPlaybackStart']
    })
], VimeControls);
let VimeCurrentTime = class VimeCurrentTime {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeCurrentTime.ɵfac = function VimeCurrentTime_Factory(t) { return new (t || VimeCurrentTime)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeCurrentTime.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeCurrentTime, selectors: [["vime-current-time"]], inputs: { alwaysShowHours: "alwaysShowHours" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeCurrentTime_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeCurrentTime.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeCurrentTime = __decorate([
    ProxyCmp({
        inputs: ['alwaysShowHours']
    })
], VimeCurrentTime);
let VimeDailymotion = class VimeDailymotion {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDailymotion.ɵfac = function VimeDailymotion_Factory(t) { return new (t || VimeDailymotion)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDailymotion.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDailymotion, selectors: [["vime-dailymotion"]], inputs: { color: "color", shouldAutoplayQueue: "shouldAutoplayQueue", showDailymotionLogo: "showDailymotionLogo", showShareButtons: "showShareButtons", showUpNextQueue: "showUpNextQueue", showVideoInfo: "showVideoInfo", syndication: "syndication", videoId: "videoId" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDailymotion_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDailymotion.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDailymotion = __decorate([
    ProxyCmp({
        inputs: ['color', 'shouldAutoplayQueue', 'showDailymotionLogo', 'showShareButtons', 'showUpNextQueue', 'showVideoInfo', 'syndication', 'videoId']
    })
], VimeDailymotion);
let VimeDash = class VimeDash {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDash.ɵfac = function VimeDash_Factory(t) { return new (t || VimeDash)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDash.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDash, selectors: [["vime-dash"]], inputs: { autoPiP: "autoPiP", config: "config", controlsList: "controlsList", crossOrigin: "crossOrigin", disablePiP: "disablePiP", disableRemotePlayback: "disableRemotePlayback", mediaTitle: "mediaTitle", poster: "poster", preload: "preload", src: "src", version: "version" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDash_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDash.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDash = __decorate([
    ProxyCmp({
        inputs: ['autoPiP', 'config', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload', 'src', 'version']
    })
], VimeDash);
let VimeDblClickFullscreen = class VimeDblClickFullscreen {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDblClickFullscreen.ɵfac = function VimeDblClickFullscreen_Factory(t) { return new (t || VimeDblClickFullscreen)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDblClickFullscreen.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDblClickFullscreen, selectors: [["vime-dbl-click-fullscreen"]], inputs: { useOnMobile: "useOnMobile" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDblClickFullscreen_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDblClickFullscreen.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDblClickFullscreen = __decorate([
    ProxyCmp({
        inputs: ['useOnMobile']
    })
], VimeDblClickFullscreen);
let VimeDefaultControls = class VimeDefaultControls {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDefaultControls.ɵfac = function VimeDefaultControls_Factory(t) { return new (t || VimeDefaultControls)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDefaultControls.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDefaultControls, selectors: [["vime-default-controls"]], inputs: { activeDuration: "activeDuration", hideOnMouseLeave: "hideOnMouseLeave", hideWhenPaused: "hideWhenPaused", waitForPlaybackStart: "waitForPlaybackStart" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDefaultControls_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDefaultControls.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDefaultControls = __decorate([
    ProxyCmp({
        inputs: ['activeDuration', 'hideOnMouseLeave', 'hideWhenPaused', 'waitForPlaybackStart']
    })
], VimeDefaultControls);
let VimeDefaultSettings = class VimeDefaultSettings {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDefaultSettings.ɵfac = function VimeDefaultSettings_Factory(t) { return new (t || VimeDefaultSettings)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDefaultSettings.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDefaultSettings, selectors: [["vime-default-settings"]], inputs: { pin: "pin" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDefaultSettings_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDefaultSettings.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDefaultSettings = __decorate([
    ProxyCmp({
        inputs: ['pin']
    })
], VimeDefaultSettings);
let VimeDefaultUi = class VimeDefaultUi {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeDefaultUi.ɵfac = function VimeDefaultUi_Factory(t) { return new (t || VimeDefaultUi)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeDefaultUi.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeDefaultUi, selectors: [["vime-default-ui"]], inputs: { noCaptions: "noCaptions", noClickToPlay: "noClickToPlay", noControls: "noControls", noDblClickFullscreen: "noDblClickFullscreen", noIcons: "noIcons", noPoster: "noPoster", noSettings: "noSettings", noSkeleton: "noSkeleton", noSpinner: "noSpinner" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeDefaultUi_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeDefaultUi.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeDefaultUi = __decorate([
    ProxyCmp({
        inputs: ['noCaptions', 'noClickToPlay', 'noControls', 'noDblClickFullscreen', 'noIcons', 'noPoster', 'noSettings', 'noSkeleton', 'noSpinner']
    })
], VimeDefaultUi);
let VimeEmbed = class VimeEmbed {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vEmbedSrcChange', 'vEmbedMessage', 'vEmbedLoaded']);
    }
};
VimeEmbed.ɵfac = function VimeEmbed_Factory(t) { return new (t || VimeEmbed)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeEmbed.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeEmbed, selectors: [["vime-embed"]], inputs: { decoder: "decoder", embedSrc: "embedSrc", mediaTitle: "mediaTitle", origin: "origin", params: "params", preconnections: "preconnections" }, outputs: { vEmbedSrcChange: "vEmbedSrcChange", vEmbedMessage: "vEmbedMessage", vEmbedLoaded: "vEmbedLoaded" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeEmbed_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeEmbed.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeEmbed = __decorate([
    ProxyCmp({
        inputs: ['decoder', 'embedSrc', 'mediaTitle', 'origin', 'params', 'preconnections'],
        methods: ['postMessage']
    })
], VimeEmbed);
let VimeEndTime = class VimeEndTime {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeEndTime.ɵfac = function VimeEndTime_Factory(t) { return new (t || VimeEndTime)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeEndTime.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeEndTime, selectors: [["vime-end-time"]], inputs: { alwaysShowHours: "alwaysShowHours" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeEndTime_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeEndTime.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeEndTime = __decorate([
    ProxyCmp({
        inputs: ['alwaysShowHours']
    })
], VimeEndTime);
let VimeFaketube = class VimeFaketube {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeFaketube.ɵfac = function VimeFaketube_Factory(t) { return new (t || VimeFaketube)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeFaketube.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeFaketube, selectors: [["vime-faketube"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeFaketube_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeFaketube.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeFaketube = __decorate([
    ProxyCmp({
        methods: ['getAdapter', 'dispatchLoadStart', 'dispatchChange']
    })
], VimeFaketube);
let VimeFile = class VimeFile {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vMediaElChange', 'vSrcSetChange']);
    }
};
VimeFile.ɵfac = function VimeFile_Factory(t) { return new (t || VimeFile)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeFile.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeFile, selectors: [["vime-file"]], inputs: { autoPiP: "autoPiP", controlsList: "controlsList", crossOrigin: "crossOrigin", disablePiP: "disablePiP", disableRemotePlayback: "disableRemotePlayback", mediaTitle: "mediaTitle", playbackRates: "playbackRates", poster: "poster", preload: "preload", viewType: "viewType" }, outputs: { vMediaElChange: "vMediaElChange", vSrcSetChange: "vSrcSetChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeFile_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeFile.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeFile = __decorate([
    ProxyCmp({
        inputs: ['autoPiP', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'playbackRates', 'poster', 'preload', 'viewType']
    })
], VimeFile);
let VimeFullscreenControl = class VimeFullscreenControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeFullscreenControl.ɵfac = function VimeFullscreenControl_Factory(t) { return new (t || VimeFullscreenControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeFullscreenControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeFullscreenControl, selectors: [["vime-fullscreen-control"]], inputs: { enterIcon: "enterIcon", exitIcon: "exitIcon", hideTooltip: "hideTooltip", keys: "keys", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeFullscreenControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeFullscreenControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeFullscreenControl = __decorate([
    ProxyCmp({
        inputs: ['enterIcon', 'exitIcon', 'hideTooltip', 'keys', 'tooltipDirection', 'tooltipPosition']
    })
], VimeFullscreenControl);
let VimeHls = class VimeHls {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeHls.ɵfac = function VimeHls_Factory(t) { return new (t || VimeHls)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeHls.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeHls, selectors: [["vime-hls"]], inputs: { autoPiP: "autoPiP", config: "config", controlsList: "controlsList", crossOrigin: "crossOrigin", disablePiP: "disablePiP", disableRemotePlayback: "disableRemotePlayback", mediaTitle: "mediaTitle", poster: "poster", preload: "preload", version: "version" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeHls_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeHls.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeHls = __decorate([
    ProxyCmp({
        inputs: ['autoPiP', 'config', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload', 'version']
    })
], VimeHls);
let VimeIcon = class VimeIcon {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeIcon.ɵfac = function VimeIcon_Factory(t) { return new (t || VimeIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeIcon.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeIcon, selectors: [["vime-icon"]], inputs: { href: "href" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeIcon.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeIcon = __decorate([
    ProxyCmp({
        inputs: ['href']
    })
], VimeIcon);
let VimeIcons = class VimeIcons {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeIcons.ɵfac = function VimeIcons_Factory(t) { return new (t || VimeIcons)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeIcons.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeIcons, selectors: [["vime-icons"]], inputs: { href: "href" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeIcons_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeIcons.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeIcons = __decorate([
    ProxyCmp({
        inputs: ['href']
    })
], VimeIcons);
class VimeLiveIndicator {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
VimeLiveIndicator.ɵfac = function VimeLiveIndicator_Factory(t) { return new (t || VimeLiveIndicator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeLiveIndicator.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeLiveIndicator, selectors: [["vime-live-indicator"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeLiveIndicator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeLiveIndicator.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let VimeMenu = class VimeMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vOpen', 'vClose', 'vMenuItemsChange', 'vFocusMenuItemChange']);
    }
};
VimeMenu.ɵfac = function VimeMenu_Factory(t) { return new (t || VimeMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeMenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeMenu, selectors: [["vime-menu"]], inputs: { active: "active", controller: "controller", identifier: "identifier" }, outputs: { vOpen: "vOpen", vClose: "vClose", vMenuItemsChange: "vMenuItemsChange", vFocusMenuItemChange: "vFocusMenuItemChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeMenu.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeMenu = __decorate([
    ProxyCmp({
        inputs: ['active', 'controller', 'identifier'],
        methods: ['getController', 'getFocusedMenuItem', 'focusOnOpen']
    })
], VimeMenu);
let VimeMenuItem = class VimeMenuItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeMenuItem.ɵfac = function VimeMenuItem_Factory(t) { return new (t || VimeMenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeMenuItem.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeMenuItem, selectors: [["vime-menu-item"]], inputs: { badge: "badge", checked: "checked", checkedIcon: "checkedIcon", expanded: "expanded", hidden: "hidden", hint: "hint", identifier: "identifier", label: "label", menu: "menu" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeMenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeMenuItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeMenuItem = __decorate([
    ProxyCmp({
        inputs: ['badge', 'checked', 'checkedIcon', 'expanded', 'hidden', 'hint', 'identifier', 'label', 'menu']
    })
], VimeMenuItem);
let VimeMenuRadio = class VimeMenuRadio {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vCheck']);
    }
};
VimeMenuRadio.ɵfac = function VimeMenuRadio_Factory(t) { return new (t || VimeMenuRadio)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeMenuRadio.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeMenuRadio, selectors: [["vime-menu-radio"]], inputs: { badge: "badge", checked: "checked", checkedIcon: "checkedIcon", label: "label", value: "value" }, outputs: { vCheck: "vCheck" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeMenuRadio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeMenuRadio.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeMenuRadio = __decorate([
    ProxyCmp({
        inputs: ['badge', 'checked', 'checkedIcon', 'label', 'value']
    })
], VimeMenuRadio);
let VimeMenuRadioGroup = class VimeMenuRadioGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vCheck']);
    }
};
VimeMenuRadioGroup.ɵfac = function VimeMenuRadioGroup_Factory(t) { return new (t || VimeMenuRadioGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeMenuRadioGroup.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeMenuRadioGroup, selectors: [["vime-menu-radio-group"]], inputs: { value: "value" }, outputs: { vCheck: "vCheck" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeMenuRadioGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeMenuRadioGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeMenuRadioGroup = __decorate([
    ProxyCmp({
        inputs: ['value']
    })
], VimeMenuRadioGroup);
let VimeMuteControl = class VimeMuteControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeMuteControl.ɵfac = function VimeMuteControl_Factory(t) { return new (t || VimeMuteControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeMuteControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeMuteControl, selectors: [["vime-mute-control"]], inputs: { hideTooltip: "hideTooltip", highVolumeIcon: "highVolumeIcon", keys: "keys", lowVolumeIcon: "lowVolumeIcon", mutedIcon: "mutedIcon", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeMuteControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeMuteControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeMuteControl = __decorate([
    ProxyCmp({
        inputs: ['hideTooltip', 'highVolumeIcon', 'keys', 'lowVolumeIcon', 'mutedIcon', 'tooltipDirection', 'tooltipPosition']
    })
], VimeMuteControl);
let VimePipControl = class VimePipControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimePipControl.ɵfac = function VimePipControl_Factory(t) { return new (t || VimePipControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimePipControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimePipControl, selectors: [["vime-pip-control"]], inputs: { enterIcon: "enterIcon", exitIcon: "exitIcon", hideTooltip: "hideTooltip", keys: "keys", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimePipControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimePipControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimePipControl = __decorate([
    ProxyCmp({
        inputs: ['enterIcon', 'exitIcon', 'hideTooltip', 'keys', 'tooltipDirection', 'tooltipPosition']
    })
], VimePipControl);
let VimePlaybackControl = class VimePlaybackControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimePlaybackControl.ɵfac = function VimePlaybackControl_Factory(t) { return new (t || VimePlaybackControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimePlaybackControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimePlaybackControl, selectors: [["vime-playback-control"]], inputs: { hideTooltip: "hideTooltip", keys: "keys", pauseIcon: "pauseIcon", playIcon: "playIcon", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimePlaybackControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimePlaybackControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimePlaybackControl = __decorate([
    ProxyCmp({
        inputs: ['hideTooltip', 'keys', 'pauseIcon', 'playIcon', 'tooltipDirection', 'tooltipPosition']
    })
], VimePlaybackControl);
let VimePlayer = class VimePlayer {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vThemeChange', 'vPausedChange', 'vPlay', 'vPlayingChange', 'vSeekingChange', 'vSeeked', 'vBufferingChange', 'vDurationChange', 'vCurrentTimeChange', 'vAttachedChange', 'vReady', 'vPlaybackReady', 'vPlaybackStarted', 'vPlaybackEnded', 'vBufferedChange', 'vCurrentCaptionChange', 'vTextTracksChange', 'vErrorsChange', 'vLoadStart', 'vCurrentSrcChange', 'vCurrentPosterChange', 'vMediaTitleChange', 'vControlsChange', 'vPlaybackRateChange', 'vPlaybackRatesChange', 'vPlaybackQualityChange', 'vPlaybackQualitiesChange', 'vMutedChange', 'vVolumeChange', 'vViewTypeChange', 'vMediaTypeChange', 'vLiveChange', 'vTouchChange', 'vLanguageChange', 'vI18nChange', 'vTranslationsChange', 'vLanguagesChange', 'vFullscreenChange', 'vPiPChange']);
    }
};
VimePlayer.ɵfac = function VimePlayer_Factory(t) { return new (t || VimePlayer)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimePlayer.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimePlayer, selectors: [["vime-player"]], inputs: { aspectRatio: "aspectRatio", attached: "attached", autopause: "autopause", autoplay: "autoplay", buffered: "buffered", buffering: "buffering", controls: "controls", currentCaption: "currentCaption", currentPoster: "currentPoster", currentSrc: "currentSrc", currentTime: "currentTime", debug: "debug", duration: "duration", errors: "errors", i18n: "i18n", isAudio: "isAudio", isAudioView: "isAudioView", isCaptionsActive: "isCaptionsActive", isControlsActive: "isControlsActive", isFullscreenActive: "isFullscreenActive", isLive: "isLive", isMobile: "isMobile", isPiPActive: "isPiPActive", isSettingsActive: "isSettingsActive", isTouch: "isTouch", isVideo: "isVideo", isVideoView: "isVideoView", language: "language", languages: "languages", loop: "loop", mediaTitle: "mediaTitle", mediaType: "mediaType", muted: "muted", paused: "paused", playbackEnded: "playbackEnded", playbackQualities: "playbackQualities", playbackQuality: "playbackQuality", playbackRate: "playbackRate", playbackRates: "playbackRates", playbackReady: "playbackReady", playbackStarted: "playbackStarted", playing: "playing", playsinline: "playsinline", ready: "ready", seeking: "seeking", textTracks: "textTracks", theme: "theme", translations: "translations", viewType: "viewType", volume: "volume" }, outputs: { vThemeChange: "vThemeChange", vPausedChange: "vPausedChange", vPlay: "vPlay", vPlayingChange: "vPlayingChange", vSeekingChange: "vSeekingChange", vSeeked: "vSeeked", vBufferingChange: "vBufferingChange", vDurationChange: "vDurationChange", vCurrentTimeChange: "vCurrentTimeChange", vAttachedChange: "vAttachedChange", vReady: "vReady", vPlaybackReady: "vPlaybackReady", vPlaybackStarted: "vPlaybackStarted", vPlaybackEnded: "vPlaybackEnded", vBufferedChange: "vBufferedChange", vCurrentCaptionChange: "vCurrentCaptionChange", vTextTracksChange: "vTextTracksChange", vErrorsChange: "vErrorsChange", vLoadStart: "vLoadStart", vCurrentSrcChange: "vCurrentSrcChange", vCurrentPosterChange: "vCurrentPosterChange", vMediaTitleChange: "vMediaTitleChange", vControlsChange: "vControlsChange", vPlaybackRateChange: "vPlaybackRateChange", vPlaybackRatesChange: "vPlaybackRatesChange", vPlaybackQualityChange: "vPlaybackQualityChange", vPlaybackQualitiesChange: "vPlaybackQualitiesChange", vMutedChange: "vMutedChange", vVolumeChange: "vVolumeChange", vViewTypeChange: "vViewTypeChange", vMediaTypeChange: "vMediaTypeChange", vLiveChange: "vLiveChange", vTouchChange: "vTouchChange", vLanguageChange: "vLanguageChange", vI18nChange: "vI18nChange", vTranslationsChange: "vTranslationsChange", vLanguagesChange: "vLanguagesChange", vFullscreenChange: "vFullscreenChange", vPiPChange: "vPiPChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimePlayer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimePlayer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimePlayer = __decorate([
    ProxyCmp({
        inputs: ['aspectRatio', 'attached', 'autopause', 'autoplay', 'buffered', 'buffering', 'controls', 'currentCaption', 'currentPoster', 'currentSrc', 'currentTime', 'debug', 'duration', 'errors', 'i18n', 'isAudio', 'isAudioView', 'isCaptionsActive', 'isControlsActive', 'isFullscreenActive', 'isLive', 'isMobile', 'isPiPActive', 'isSettingsActive', 'isTouch', 'isVideo', 'isVideoView', 'language', 'languages', 'loop', 'mediaTitle', 'mediaType', 'muted', 'paused', 'playbackEnded', 'playbackQualities', 'playbackQuality', 'playbackRate', 'playbackRates', 'playbackReady', 'playbackStarted', 'playing', 'playsinline', 'ready', 'seeking', 'textTracks', 'theme', 'translations', 'viewType', 'volume'],
        methods: ['getProvider', 'play', 'pause', 'canPlay', 'canAutoplay', 'canMutedAutoplay', 'canSetPlaybackRate', 'canSetPlaybackQuality', 'canSetFullscreen', 'enterFullscreen', 'exitFullscreen', 'canSetPiP', 'enterPiP', 'exitPiP', 'extendLanguage', 'toggleCaptionsVisibility']
    })
], VimePlayer);
let VimePoster = class VimePoster {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vLoaded', 'vWillShow', 'vWillHide']);
    }
};
VimePoster.ɵfac = function VimePoster_Factory(t) { return new (t || VimePoster)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimePoster.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimePoster, selectors: [["vime-poster"]], inputs: { fit: "fit" }, outputs: { vLoaded: "vLoaded", vWillShow: "vWillShow", vWillHide: "vWillHide" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimePoster_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimePoster.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimePoster = __decorate([
    ProxyCmp({
        inputs: ['fit']
    })
], VimePoster);
let VimeScrim = class VimeScrim {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeScrim.ɵfac = function VimeScrim_Factory(t) { return new (t || VimeScrim)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeScrim.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeScrim, selectors: [["vime-scrim"]], inputs: { gradient: "gradient" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeScrim_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeScrim.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeScrim = __decorate([
    ProxyCmp({
        inputs: ['gradient']
    })
], VimeScrim);
let VimeScrubberControl = class VimeScrubberControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeScrubberControl.ɵfac = function VimeScrubberControl_Factory(t) { return new (t || VimeScrubberControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeScrubberControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeScrubberControl, selectors: [["vime-scrubber-control"]], inputs: { alwaysShowHours: "alwaysShowHours", hideTooltip: "hideTooltip", noKeyboard: "noKeyboard" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeScrubberControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeScrubberControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeScrubberControl = __decorate([
    ProxyCmp({
        inputs: ['alwaysShowHours', 'hideTooltip', 'noKeyboard']
    })
], VimeScrubberControl);
let VimeSettings = class VimeSettings {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeSettings.ɵfac = function VimeSettings_Factory(t) { return new (t || VimeSettings)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSettings.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSettings, selectors: [["vime-settings"]], inputs: { active: "active", controlsHeight: "controlsHeight", pin: "pin" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSettings_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSettings.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeSettings = __decorate([
    ProxyCmp({
        inputs: ['active', 'controlsHeight', 'pin'],
        methods: ['setController']
    })
], VimeSettings);
let VimeSettingsControl = class VimeSettingsControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeSettingsControl.ɵfac = function VimeSettingsControl_Factory(t) { return new (t || VimeSettingsControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSettingsControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSettingsControl, selectors: [["vime-settings-control"]], inputs: { expanded: "expanded", icon: "icon", menu: "menu", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSettingsControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSettingsControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeSettingsControl = __decorate([
    ProxyCmp({
        inputs: ['expanded', 'icon', 'menu', 'tooltipDirection', 'tooltipPosition']
    })
], VimeSettingsControl);
let VimeSkeleton = class VimeSkeleton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeSkeleton.ɵfac = function VimeSkeleton_Factory(t) { return new (t || VimeSkeleton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSkeleton.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSkeleton, selectors: [["vime-skeleton"]], inputs: { effect: "effect" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSkeleton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSkeleton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeSkeleton = __decorate([
    ProxyCmp({
        inputs: ['effect']
    })
], VimeSkeleton);
let VimeSlider = class VimeSlider {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vValueChange']);
    }
};
VimeSlider.ɵfac = function VimeSlider_Factory(t) { return new (t || VimeSlider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSlider.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSlider, selectors: [["vime-slider"]], inputs: { label: "label", max: "max", min: "min", step: "step", value: "value", valueText: "valueText" }, outputs: { vValueChange: "vValueChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSlider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSlider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeSlider = __decorate([
    ProxyCmp({
        inputs: ['label', 'max', 'min', 'step', 'value', 'valueText']
    })
], VimeSlider);
class VimeSpinner {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['vWillShow', 'vWillHide']);
    }
}
VimeSpinner.ɵfac = function VimeSpinner_Factory(t) { return new (t || VimeSpinner)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSpinner.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSpinner, selectors: [["vime-spinner"]], outputs: { vWillShow: "vWillShow", vWillHide: "vWillHide" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSpinner_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSpinner.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let VimeSubmenu = class VimeSubmenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeSubmenu.ɵfac = function VimeSubmenu_Factory(t) { return new (t || VimeSubmenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeSubmenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeSubmenu, selectors: [["vime-submenu"]], inputs: { active: "active", hidden: "hidden", hint: "hint", label: "label" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeSubmenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeSubmenu.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeSubmenu = __decorate([
    ProxyCmp({
        inputs: ['active', 'hidden', 'hint', 'label']
    })
], VimeSubmenu);
let VimeTime = class VimeTime {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeTime.ɵfac = function VimeTime_Factory(t) { return new (t || VimeTime)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeTime.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeTime, selectors: [["vime-time"]], inputs: { alwaysShowHours: "alwaysShowHours", label: "label", seconds: "seconds" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeTime_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeTime.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeTime = __decorate([
    ProxyCmp({
        inputs: ['alwaysShowHours', 'label', 'seconds']
    })
], VimeTime);
let VimeTimeProgress = class VimeTimeProgress {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeTimeProgress.ɵfac = function VimeTimeProgress_Factory(t) { return new (t || VimeTimeProgress)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeTimeProgress.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeTimeProgress, selectors: [["vime-time-progress"]], inputs: { alwaysShowHours: "alwaysShowHours", separator: "separator" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeTimeProgress_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeTimeProgress.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeTimeProgress = __decorate([
    ProxyCmp({
        inputs: ['alwaysShowHours', 'separator']
    })
], VimeTimeProgress);
let VimeTooltip = class VimeTooltip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeTooltip.ɵfac = function VimeTooltip_Factory(t) { return new (t || VimeTooltip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeTooltip.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeTooltip, selectors: [["vime-tooltip"]], inputs: { active: "active", direction: "direction", hidden: "hidden", position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeTooltip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeTooltip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeTooltip = __decorate([
    ProxyCmp({
        inputs: ['active', 'direction', 'hidden', 'position']
    })
], VimeTooltip);
class VimeUi {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
VimeUi.ɵfac = function VimeUi_Factory(t) { return new (t || VimeUi)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeUi.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeUi, selectors: [["vime-ui"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeUi_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeUi.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let VimeVideo = class VimeVideo {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeVideo.ɵfac = function VimeVideo_Factory(t) { return new (t || VimeVideo)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeVideo.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeVideo, selectors: [["vime-video"]], inputs: { autoPiP: "autoPiP", controlsList: "controlsList", crossOrigin: "crossOrigin", disablePiP: "disablePiP", disableRemotePlayback: "disableRemotePlayback", mediaTitle: "mediaTitle", poster: "poster", preload: "preload" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeVideo_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeVideo.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeVideo = __decorate([
    ProxyCmp({
        inputs: ['autoPiP', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload']
    })
], VimeVideo);
let VimeVimeo = class VimeVimeo {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeVimeo.ɵfac = function VimeVimeo_Factory(t) { return new (t || VimeVimeo)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeVimeo.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeVimeo, selectors: [["vime-vimeo"]], inputs: { byline: "byline", color: "color", portrait: "portrait", videoId: "videoId" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeVimeo_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeVimeo.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeVimeo = __decorate([
    ProxyCmp({
        inputs: ['byline', 'color', 'portrait', 'videoId']
    })
], VimeVimeo);
let VimeVolumeControl = class VimeVolumeControl {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeVolumeControl.ɵfac = function VimeVolumeControl_Factory(t) { return new (t || VimeVolumeControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeVolumeControl.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeVolumeControl, selectors: [["vime-volume-control"]], inputs: { hideTooltip: "hideTooltip", highVolumeIcon: "highVolumeIcon", lowVolumeIcon: "lowVolumeIcon", muteKeys: "muteKeys", mutedIcon: "mutedIcon", noKeyboard: "noKeyboard", tooltipDirection: "tooltipDirection", tooltipPosition: "tooltipPosition" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeVolumeControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeVolumeControl.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeVolumeControl = __decorate([
    ProxyCmp({
        inputs: ['hideTooltip', 'highVolumeIcon', 'lowVolumeIcon', 'muteKeys', 'mutedIcon', 'noKeyboard', 'tooltipDirection', 'tooltipPosition']
    })
], VimeVolumeControl);
let VimeYoutube = class VimeYoutube {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
VimeYoutube.ɵfac = function VimeYoutube_Factory(t) { return new (t || VimeYoutube)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
VimeYoutube.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VimeYoutube, selectors: [["vime-youtube"]], inputs: { cookies: "cookies", showFullscreenControl: "showFullscreenControl", videoId: "videoId" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function VimeYoutube_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
VimeYoutube.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
VimeYoutube = __decorate([
    ProxyCmp({
        inputs: ['cookies', 'showFullscreenControl', 'videoId']
    })
], VimeYoutube);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeAudio, [{
        type: Component,
        args: [{
                selector: 'vime-audio',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['crossOrigin', 'disableRemotePlayback', 'mediaTitle', 'preload']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeCaptionControl, [{
        type: Component,
        args: [{
                selector: 'vime-caption-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['hideIcon', 'hideTooltip', 'keys', 'showIcon', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeCaptions, [{
        type: Component,
        args: [{
                selector: 'vime-captions',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['controlsHeight', 'hidden'],
                outputs: ['vTrackChange', 'vCuesChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeClickToPlay, [{
        type: Component,
        args: [{
                selector: 'vime-click-to-play',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['useOnMobile']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeControl, [{
        type: Component,
        args: [{
                selector: 'vime-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['expanded', 'hidden', 'identifier', 'keys', 'label', 'menu', 'pressed'],
                outputs: ['vInteractionChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeControlGroup, [{
        type: Component,
        args: [{
                selector: 'vime-control-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['space']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeControlSpacer, [{
        type: Component,
        args: [{
                selector: 'vime-control-spacer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeControls, [{
        type: Component,
        args: [{
                selector: 'vime-controls',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['activeDuration', 'align', 'direction', 'fullHeight', 'fullWidth', 'hidden', 'hideOnMouseLeave', 'hideWhenPaused', 'justify', 'pin', 'waitForPlaybackStart']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeCurrentTime, [{
        type: Component,
        args: [{
                selector: 'vime-current-time',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alwaysShowHours']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDailymotion, [{
        type: Component,
        args: [{
                selector: 'vime-dailymotion',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['color', 'shouldAutoplayQueue', 'showDailymotionLogo', 'showShareButtons', 'showUpNextQueue', 'showVideoInfo', 'syndication', 'videoId']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDash, [{
        type: Component,
        args: [{
                selector: 'vime-dash',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoPiP', 'config', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload', 'src', 'version']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDblClickFullscreen, [{
        type: Component,
        args: [{
                selector: 'vime-dbl-click-fullscreen',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['useOnMobile']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDefaultControls, [{
        type: Component,
        args: [{
                selector: 'vime-default-controls',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['activeDuration', 'hideOnMouseLeave', 'hideWhenPaused', 'waitForPlaybackStart']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDefaultSettings, [{
        type: Component,
        args: [{
                selector: 'vime-default-settings',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['pin']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeDefaultUi, [{
        type: Component,
        args: [{
                selector: 'vime-default-ui',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['noCaptions', 'noClickToPlay', 'noControls', 'noDblClickFullscreen', 'noIcons', 'noPoster', 'noSettings', 'noSkeleton', 'noSpinner']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeEmbed, [{
        type: Component,
        args: [{
                selector: 'vime-embed',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['decoder', 'embedSrc', 'mediaTitle', 'origin', 'params', 'preconnections'],
                outputs: ['vEmbedSrcChange', 'vEmbedMessage', 'vEmbedLoaded']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeEndTime, [{
        type: Component,
        args: [{
                selector: 'vime-end-time',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alwaysShowHours']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeFaketube, [{
        type: Component,
        args: [{
                selector: 'vime-faketube',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeFile, [{
        type: Component,
        args: [{
                selector: 'vime-file',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoPiP', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'playbackRates', 'poster', 'preload', 'viewType'],
                outputs: ['vMediaElChange', 'vSrcSetChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeFullscreenControl, [{
        type: Component,
        args: [{
                selector: 'vime-fullscreen-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['enterIcon', 'exitIcon', 'hideTooltip', 'keys', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeHls, [{
        type: Component,
        args: [{
                selector: 'vime-hls',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoPiP', 'config', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload', 'version']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeIcon, [{
        type: Component,
        args: [{
                selector: 'vime-icon',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['href']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeIcons, [{
        type: Component,
        args: [{
                selector: 'vime-icons',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['href']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeLiveIndicator, [{
        type: Component,
        args: [{
                selector: 'vime-live-indicator',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeMenu, [{
        type: Component,
        args: [{
                selector: 'vime-menu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'controller', 'identifier'],
                outputs: ['vOpen', 'vClose', 'vMenuItemsChange', 'vFocusMenuItemChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeMenuItem, [{
        type: Component,
        args: [{
                selector: 'vime-menu-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['badge', 'checked', 'checkedIcon', 'expanded', 'hidden', 'hint', 'identifier', 'label', 'menu']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeMenuRadio, [{
        type: Component,
        args: [{
                selector: 'vime-menu-radio',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['badge', 'checked', 'checkedIcon', 'label', 'value'],
                outputs: ['vCheck']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeMenuRadioGroup, [{
        type: Component,
        args: [{
                selector: 'vime-menu-radio-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['value'],
                outputs: ['vCheck']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeMuteControl, [{
        type: Component,
        args: [{
                selector: 'vime-mute-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['hideTooltip', 'highVolumeIcon', 'keys', 'lowVolumeIcon', 'mutedIcon', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimePipControl, [{
        type: Component,
        args: [{
                selector: 'vime-pip-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['enterIcon', 'exitIcon', 'hideTooltip', 'keys', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimePlaybackControl, [{
        type: Component,
        args: [{
                selector: 'vime-playback-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['hideTooltip', 'keys', 'pauseIcon', 'playIcon', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimePlayer, [{
        type: Component,
        args: [{
                selector: 'vime-player',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['aspectRatio', 'attached', 'autopause', 'autoplay', 'buffered', 'buffering', 'controls', 'currentCaption', 'currentPoster', 'currentSrc', 'currentTime', 'debug', 'duration', 'errors', 'i18n', 'isAudio', 'isAudioView', 'isCaptionsActive', 'isControlsActive', 'isFullscreenActive', 'isLive', 'isMobile', 'isPiPActive', 'isSettingsActive', 'isTouch', 'isVideo', 'isVideoView', 'language', 'languages', 'loop', 'mediaTitle', 'mediaType', 'muted', 'paused', 'playbackEnded', 'playbackQualities', 'playbackQuality', 'playbackRate', 'playbackRates', 'playbackReady', 'playbackStarted', 'playing', 'playsinline', 'ready', 'seeking', 'textTracks', 'theme', 'translations', 'viewType', 'volume'],
                outputs: ['vThemeChange', 'vPausedChange', 'vPlay', 'vPlayingChange', 'vSeekingChange', 'vSeeked', 'vBufferingChange', 'vDurationChange', 'vCurrentTimeChange', 'vAttachedChange', 'vReady', 'vPlaybackReady', 'vPlaybackStarted', 'vPlaybackEnded', 'vBufferedChange', 'vCurrentCaptionChange', 'vTextTracksChange', 'vErrorsChange', 'vLoadStart', 'vCurrentSrcChange', 'vCurrentPosterChange', 'vMediaTitleChange', 'vControlsChange', 'vPlaybackRateChange', 'vPlaybackRatesChange', 'vPlaybackQualityChange', 'vPlaybackQualitiesChange', 'vMutedChange', 'vVolumeChange', 'vViewTypeChange', 'vMediaTypeChange', 'vLiveChange', 'vTouchChange', 'vLanguageChange', 'vI18nChange', 'vTranslationsChange', 'vLanguagesChange', 'vFullscreenChange', 'vPiPChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimePoster, [{
        type: Component,
        args: [{
                selector: 'vime-poster',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['fit'],
                outputs: ['vLoaded', 'vWillShow', 'vWillHide']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeScrim, [{
        type: Component,
        args: [{
                selector: 'vime-scrim',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['gradient']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeScrubberControl, [{
        type: Component,
        args: [{
                selector: 'vime-scrubber-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alwaysShowHours', 'hideTooltip', 'noKeyboard']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSettings, [{
        type: Component,
        args: [{
                selector: 'vime-settings',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'controlsHeight', 'pin']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSettingsControl, [{
        type: Component,
        args: [{
                selector: 'vime-settings-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['expanded', 'icon', 'menu', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSkeleton, [{
        type: Component,
        args: [{
                selector: 'vime-skeleton',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['effect']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSlider, [{
        type: Component,
        args: [{
                selector: 'vime-slider',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['label', 'max', 'min', 'step', 'value', 'valueText'],
                outputs: ['vValueChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSpinner, [{
        type: Component,
        args: [{
                selector: 'vime-spinner',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                outputs: ['vWillShow', 'vWillHide']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeSubmenu, [{
        type: Component,
        args: [{
                selector: 'vime-submenu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'hidden', 'hint', 'label']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeTime, [{
        type: Component,
        args: [{
                selector: 'vime-time',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alwaysShowHours', 'label', 'seconds']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeTimeProgress, [{
        type: Component,
        args: [{
                selector: 'vime-time-progress',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alwaysShowHours', 'separator']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeTooltip, [{
        type: Component,
        args: [{
                selector: 'vime-tooltip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'direction', 'hidden', 'position']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeUi, [{
        type: Component,
        args: [{
                selector: 'vime-ui',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeVideo, [{
        type: Component,
        args: [{
                selector: 'vime-video',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoPiP', 'controlsList', 'crossOrigin', 'disablePiP', 'disableRemotePlayback', 'mediaTitle', 'poster', 'preload']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeVimeo, [{
        type: Component,
        args: [{
                selector: 'vime-vimeo',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['byline', 'color', 'portrait', 'videoId']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeVolumeControl, [{
        type: Component,
        args: [{
                selector: 'vime-volume-control',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['hideTooltip', 'highVolumeIcon', 'lowVolumeIcon', 'muteKeys', 'mutedIcon', 'noKeyboard', 'tooltipDirection', 'tooltipPosition']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeYoutube, [{
        type: Component,
        args: [{
                selector: 'vime-youtube',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['cookies', 'showFullscreenControl', 'videoId']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();

defineCustomElements();
const DECLARATIONS = [
    VimePlayer,
    VimeAudio,
    VimeCaptionControl,
    VimeCaptions,
    VimeClickToPlay,
    VimeDblClickFullscreen,
    VimeSkeleton,
    VimeControl,
    VimeControlGroup,
    VimeControlSpacer,
    VimeControls,
    VimeCurrentTime,
    VimeDailymotion,
    VimeDash,
    VimeDefaultControls,
    VimeDefaultSettings,
    VimeDefaultUi,
    VimeEmbed,
    VimeEndTime,
    VimeFaketube,
    VimeFile,
    VimeFullscreenControl,
    VimeHls,
    VimeIcon,
    VimeIcons,
    VimeLiveIndicator,
    VimeMenu,
    VimeMenuItem,
    VimeMenuRadio,
    VimeMenuRadioGroup,
    VimeMuteControl,
    VimePipControl,
    VimePlaybackControl,
    VimePoster,
    VimeScrim,
    VimeScrubberControl,
    VimeSettings,
    VimeSettingsControl,
    VimeSlider,
    VimeSpinner,
    VimeSubmenu,
    VimeTime,
    VimeTimeProgress,
    VimeTooltip,
    VimeUi,
    VimeVideo,
    VimeVimeo,
    VimeVolumeControl,
    VimeYoutube,
];
class VimeModule {
}
VimeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: VimeModule });
VimeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function VimeModule_Factory(t) { return new (t || VimeModule)(); }, providers: [], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VimeModule, { declarations: [VimePlayer,
        VimeAudio,
        VimeCaptionControl,
        VimeCaptions,
        VimeClickToPlay,
        VimeDblClickFullscreen,
        VimeSkeleton,
        VimeControl,
        VimeControlGroup,
        VimeControlSpacer,
        VimeControls,
        VimeCurrentTime,
        VimeDailymotion,
        VimeDash,
        VimeDefaultControls,
        VimeDefaultSettings,
        VimeDefaultUi,
        VimeEmbed,
        VimeEndTime,
        VimeFaketube,
        VimeFile,
        VimeFullscreenControl,
        VimeHls,
        VimeIcon,
        VimeIcons,
        VimeLiveIndicator,
        VimeMenu,
        VimeMenuItem,
        VimeMenuRadio,
        VimeMenuRadioGroup,
        VimeMuteControl,
        VimePipControl,
        VimePlaybackControl,
        VimePoster,
        VimeScrim,
        VimeScrubberControl,
        VimeSettings,
        VimeSettingsControl,
        VimeSlider,
        VimeSpinner,
        VimeSubmenu,
        VimeTime,
        VimeTimeProgress,
        VimeTooltip,
        VimeUi,
        VimeVideo,
        VimeVimeo,
        VimeVolumeControl,
        VimeYoutube], exports: [VimePlayer,
        VimeAudio,
        VimeCaptionControl,
        VimeCaptions,
        VimeClickToPlay,
        VimeDblClickFullscreen,
        VimeSkeleton,
        VimeControl,
        VimeControlGroup,
        VimeControlSpacer,
        VimeControls,
        VimeCurrentTime,
        VimeDailymotion,
        VimeDash,
        VimeDefaultControls,
        VimeDefaultSettings,
        VimeDefaultUi,
        VimeEmbed,
        VimeEndTime,
        VimeFaketube,
        VimeFile,
        VimeFullscreenControl,
        VimeHls,
        VimeIcon,
        VimeIcons,
        VimeLiveIndicator,
        VimeMenu,
        VimeMenuItem,
        VimeMenuRadio,
        VimeMenuRadioGroup,
        VimeMuteControl,
        VimePipControl,
        VimePlaybackControl,
        VimePoster,
        VimeScrim,
        VimeScrubberControl,
        VimeSettings,
        VimeSettingsControl,
        VimeSlider,
        VimeSpinner,
        VimeSubmenu,
        VimeTime,
        VimeTimeProgress,
        VimeTooltip,
        VimeUi,
        VimeVideo,
        VimeVimeo,
        VimeVolumeControl,
        VimeYoutube] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VimeModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARATIONS,
                exports: DECLARATIONS,
                imports: [],
                providers: []
            }]
    }], null, null); })();

class VimeComponent {
    constructor(playerProps) {
        this.playerProps = playerProps;
        this.playerDispatch = () => { };
        this.unbindPlayerContext = () => { };
        this.playerCache = new Map();
        playerProps.forEach((prop) => { this.playerCache.set(prop, this[prop]); });
        const props = playerProps.reduce((prev, prop) => (Object.assign(Object.assign({}, prev), { [prop]: {
                get() {
                    return this.playerCache.get(prop);
                },
                set: (value) => {
                    if (this.playerCache.get(prop) !== value)
                        this.playerDispatch(prop, value);
                    this.playerCache.set(prop, value);
                },
            } })), {});
        Object.defineProperties(this, props);
    }
    ngAfterViewInit() {
        this.player = findRootPlayer(this.ref.nativeElement);
        this.playerDispatch = createDispatcher(this.ref.nativeElement);
        this.unbindPlayerContext = usePlayerContext(this.ref.nativeElement, this.playerProps, (prop, value) => {
            this.playerCache.set(prop, value);
            this[prop] = value;
        });
    }
    ngOnDestroy() {
        this.unbindPlayerContext();
        this.playerCache.clear();
    }
}
VimeComponent.ɵfac = function VimeComponent_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
VimeComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: VimeComponent });


/**
 * Generated bundle index. Do not edit.
 */

export { VimeAudio, VimeCaptionControl, VimeCaptions, VimeClickToPlay, VimeComponent, VimeControl, VimeControlGroup, VimeControlSpacer, VimeControls, VimeCurrentTime, VimeDailymotion, VimeDash, VimeDblClickFullscreen, VimeDefaultControls, VimeDefaultSettings, VimeDefaultUi, VimeEmbed, VimeEndTime, VimeFaketube, VimeFile, VimeFullscreenControl, VimeHls, VimeIcon, VimeIcons, VimeLiveIndicator, VimeMenu, VimeMenuItem, VimeMenuRadio, VimeMenuRadioGroup, VimeModule, VimeMuteControl, VimePipControl, VimePlaybackControl, VimePlayer, VimePoster, VimeScrim, VimeScrubberControl, VimeSettings, VimeSettingsControl, VimeSkeleton, VimeSlider, VimeSpinner, VimeSubmenu, VimeTime, VimeTimeProgress, VimeTooltip, VimeUi, VimeVideo, VimeVimeo, VimeVolumeControl, VimeYoutube, ProxyCmp as ɵa };

//# sourceMappingURL=vime-angular.js.map